import type { ActivityComponentType } from '@stackflow/react';
import { ThreadPanel } from '@/features/messaging/components/ThreadPanel';
import { useMessages } from '@/features/messaging/hooks';
import { useMemo } from 'react';
import { useMessagingFlow } from '@/stackflow';

type Params = { conversationId: string; messageId: string };

const ThreadActivity: ActivityComponentType<Params> = ({ params }) => {
  const { pop } = useMessagingFlow();
  const { data: messagesData } = useMessages(params.conversationId);

  const rootMessage = useMemo(() => {
    if (!messagesData?.pages) return null;
    for (const page of messagesData.pages) {
      const msg = page.messages.find(m => m.id === params.messageId);
      if (msg) return msg;
    }
    return null;
  }, [messagesData, params.messageId]);

  if (!rootMessage) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="h-6 w-6 animate-spin rounded-full border border-white/20 border-t-slate-800" />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-white/80 backdrop-blur-xl">
      <ThreadPanel
        conversationId={params.conversationId}
        rootMessage={rootMessage}
        onClose={() => pop()}
      />
    </div>
  );
};

export default ThreadActivity;
